module.exports = __webpack_public_path__ + "img/p139.3b859dc2.jpg";